/**
 * JeriCommerce Pass API · staging
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 202610.20.01
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ProfileFormSectionAction = 'dismiss' | 'submit';

export const ProfileFormSectionAction = {
    Dismiss: 'dismiss' as ProfileFormSectionAction,
    Submit: 'submit' as ProfileFormSectionAction
};

